module.exports = "<md-input-container flex=50> <a href={{csvDownloadLink}} target=blank class=\"md-primary md-hue-1 tolowercase\"> <i class=\"fas fa-file-download\"></i> Download Sample-CSV </a> </md-input-container> <md-input-container flex=50> <i ngf-select ngf-change=upload($file) tooltip=Upload tooltip-position=down flex=50 class=\"fas fa-cloud-upload-alt\"></i> <i class=\"fas fa-search\" ng-if=showViewButton ng-click=showCsv() flex=50 tooltip=Preview tooltip-position=down></i> </md-input-container> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/createQuestion/views/shortBulkUpload.html
// module id = 1291
// module chunks = 453